<template>
    <template v-if="showMenu">
        <slot></slot>
    </template>
    <template v-else>
        <div class="layouts layouts_left_right" :style="{ width: `${windowWidth}px`, height: `${windowHeight}` }">
            <div class="layouts_header">
                <logo-title ref="logoRef"></logo-title>
                <layouts-header></layouts-header>
            </div>
            <div class="layouts_right" :style="{ width: `calc(${windowWidth}px - 202px)` }">
                <div class="layouts_left">
                    <layouts-menu @onSetUnfold="onSetUnfold"></layouts-menu>
                </div>
                <div class="layouts_content">
                    <slot></slot>
                </div>
            </div>
        </div>
    </template>
</template>
<script>
import LayoutsHeader from "./header.vue";
import LayoutsMenu from "./menu.vue";
import LogoTitle from "./logoTitle.vue";
import { useRoute, useRouter } from 'vue-router';
import { noLayoutsPath } from '@/defaultData/route';
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { message } from "ant-design-vue";

export default {
    name: "layouts_name",
    data() {
        return {
            currenPath: null,
            noPath: []
        }
    },
    components: {
        LayoutsHeader,
        LayoutsMenu,
        LogoTitle
    },
    setup() {
        const router = useRouter();
        const windowWidth = ref(window.clientWidth);
        const windowHeight = ref(window.clientHeight);
        const route = useRoute();
        const showMenu = computed(() => {
            return noLayoutsPath.includes(route.path);
        });
        const logoRef = ref(null);

        /**
         * @function 设置isUnfold
         */
        const onSetUnfold = (val) => {
            logoRef.value.isUnfold = val;
        };

        function handleResize() {
            windowWidth.value = window.clientWidth;
            windowHeight.value = window.clientHeight;
        }

        onMounted(() => {
            window.addEventListener('resize', handleResize);
            if (location.pathname.includes('/throwInManage/outerOrder/') && !location.pathname.includes('/throwInManage/outerOrder/saleRebate_outer') && !location.href.includes('source=2')) {
                if (!sessionStorage.getItem('outer_order_record')) {
                    message.warning('没有客户名称，自动跳转至外部下单管理！');
                    router.replace('/throwInManage/outerOrder');
                    setTimeout(() => {
                        location.reload();
                    }, 100);
                }
            }
        });

        onUnmounted(() => {
            window.removeEventListener('resize', handleResize);
        });

        return {
            windowWidth,
            windowHeight,
            showMenu,
            logoRef,
            onSetUnfold
        };
    }
}
</script>
<style lang="scss">
.layouts {
    height: 100%;

    .layouts_header {
        height: 56px;
        background: #fff;
        box-shadow: 0 5px 5px rgba(0, 0, 0, 0.02);
        position: relative;
        z-index: 100;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .layouts_right {
        min-width: 1242px;
        height: 100%;
        overflow-x: auto;
        display: flex;
        align-items: flex-start;
        justify-content: space-between;

        .layouts_left {
            height: 100%;
            background: #fff;
            flex-shrink: 0;
        }

        .layouts_content {
            width: 100%;
            padding: 16px;
            height: calc(100% - 56px);
            overflow: auto;
        }
    }
}
</style>